<template>
  <div class="step step--career-major">
    <button-back @back="back"></button-back>
    <div class="text-center">
      <div align-h="center">
        <div xl="8" md="8" sm="12">
          <div class="mb-4">
            <h2>OK, let’s explore the majors you’re considering.</h2>
            <p>Enter up to 3 majors.</p>
          </div>
          <div class="step__multiselect">
            <!-- <select v-model="user.major">
              <option v-for="degree in lists.degrees" v-bind:key="degree">{{ degree }}</option>
            </select> -->
            <multiselect ref="majorSelect" v-model="user.majors" :options="lists.degrees" :multiple="true" placeholder="" :max="max" @input="onChange">
              <template slot="tag" slot-scope="{ option, remove }">
                <span class="custom__tag">
                  <span class="custom__tag-label">Enter a major</span>
                  <span>{{ option }}</span><span class="custom__remove" @click="remove(option)"></span>
                </span>
              </template>
              <template slot="clear" slot-scope="props">
                <div class="multiselect__clear" v-if="user.majors.length" @mousedown.prevent.stop="clearAll(props.search)"></div>
              </template>
              <span slot="noResult" slot-scope="{ search }">We can’t find a match for {{ search }}. Try entering a broader term or subject.</span>
              <template slot="option" slot-scope="{ option, search }">
                <span v-html="customLabel(option, search)"></span>
              </template>
            </multiselect>
            <div class="multiselect__label">
              Enter a major
            </div>
          </div>
          <div cols="12" class="buttons">
            <b-button v-on:click="submit" variant="primary" block :disabled="user.majors.length < 1">Continue</b-button>
            <b-button v-on:click="next" variant="outline" block>Not sure</b-button>
          </div>
        </div>
      </div>
      <div class="text-left no-gutters" align-h="center">
        <disclaimer />
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import ButtonBack from '../buttons/Back.vue'
import Disclaimer from '../Disclaimer.vue'

export default {
  name: 'CareerMajorStep',
  props: {
    user: Object,
    lists: Object
  },
  components: {
    Multiselect,
    ButtonBack,
    Disclaimer
  },
  data (){
    return {
      max: 3
    }
  },
  mounted: function(){
    this.onChange();
  },
  methods: {
    customLabel: function(option, search){
      if( search !== '' &&  `${option}`.toLowerCase().split(search).length > 1) {
        var oldHTML = `${option}`;
        var regex = new RegExp('(' + search + ')', 'i');
        return oldHTML.replace(regex, '<span class="highlight">$1</span>')
      } else {
        return `${option}`;
      }
    },
    onChange: function(){
      setTimeout(function(){
        var container = this.$refs.majorSelect.$el.parentElement;
        var searchInput = this.$refs.majorSelect.$refs.search;

        if ( this.$refs.majorSelect.value.length >= this.max ) {
          searchInput.style.display = 'none';
          searchInput.setAttribute('disabled', 'disabled');
          container.classList.add('limit');
        } else {
          searchInput.style.display = 'block';
          searchInput.removeAttribute('disabled');
          container.classList.remove('limit');
        }
      }.bind(this), 0);
    },
    back: function () {
      this.$emit('back');
    },
    submit: function () {
      this.user.majorKnown = 'yes';
      this.$emit('completed');
    },
    next: function() {
      this.user.majorKnown = 'no';
      this.$emit('completed');
    },
  }
}
</script>

<style scoped>
</style>
